import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone : true,
  name: 'isAllSelected',
})
export class IsAllSelectedPipe<T> implements PipeTransform {
  transform(source : T[] = [] , selectedValues : T[] = []) : boolean {
    return source.every(item => selectedValues.includes(item));
  }
}
